// 设计执行院长菜单

let menuED = [
    // {
    //     path:'/',
    //     component: "HomeView",
    //     redirect: '/home/IndexView',
    //     name: '首页',
    //     parent:true,
    //     children:[
    //         {
    //             pageAddress:"IndexView",
    //             path:"/home/IndexView",
    //             component:"IndexView",
    //             name:"实时数据",
    //         }
    //     ]

    // },
    // {
    //     path: '/p0',
    //     component: "HomeView",
    //     name: '营销管理',
    //     disable:true,//无权限
    // },
    // {
    //     path: '/p1',
    //     component: "HomeView",
    //     name: '运营管理',
    //     disable:true,//无权限
    // },
	
    // {
	// 	path:'/p2',
    //     redirect: '/common/CMcontractData',
    //     component: "HomeView",
    //     name: '合同管理',
    //     parent:true,
    //     children:[
    //         {
    //             parent:true,
    //             component:"Navigation",
    //             path:"/home",
    //             name:"合同管理",
    //             children:[
    //                 // {
    //                 //     pageAddress:"cm/CMcontractData",
    //                 //     path:"/common/CMcontractData",
    //                 //     component:"contractData",
    //                 //     name:"合同总纲",
    //                 //     meta:{
    //                 //         keepAlive:true,
    //                 //     }
    //                 // },
    //                 // {
    //                 //     pageAddress:"cm/CMProjectModifyList",
    //                 //     path:"/cm/project/CMProjectModifyList",
    //                 //     component:"CMProjectModifyList",
    //                 //     name:"变更合同"
    //                 // },
    //                 {
    //                     pageAddress:"CommonContractModifyDetail",
    //                     path:"/common/contractModify/CommonContractModifyDetail",
    //                     hidden:true,
    //                     name:"变更合同详情"
    //                 },
    //                 {
    //                     pageAddress:"commonPage/dataReport/contractDataInfo",
    //                     path:"/common/contractDataInfo",
    //                     component:"contractDataInfo",
    //                     hidden:true,
    //                     name:"合同总纲详情",
    //                 },
    //                 // {
    //                 //     pageAddress:"ed/EDContractList",
    //                 //     path:"/ED/EDContractList",
    //                 //     component:"EDContractList",
    //                 //     name:"设计合同列表"
    //                 // },
    //                 {
    //                     pageAddress:"CommonContractReadView",
    //                     path:"/cm/contract/read_view",
    //                     hidden:true,
    //                     name:"设计合同详情"
    //                 },
    //             ]
    //         }
    //     ]

    // },
    // {
    //     path: '/p3',
    //     component: "HomeView",
    //     name: '工程管理',
    //     disable:true,//无权限
    // },
    // {
    //     path: '/p4',
    //     component: "HomeView",
    //     name: '材料管理',
    //     disable:true,//无权限
    // },
    // {
    //     path: '/p5',
    //     component: "HomeView",
    //     name: '财务管理',
    //     disable:true,//无权限
    // },
    {
		path:'/p6',
        redirect: '/ba/cm/projectManagerList',
        component: "HomeView",
        name: '项目总监管理',
        parent:true,
        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"项目总监",
                children:[
                    // {
                    //     pageAddress:"ProjectManagerListView",
                    //     path:"/ba/cm/projectManagerList",
                    //     component:"ProjectManagerListView",
                    //     name:"项目总监总表"
                    // },
                    {
                        pageAddress:"cd/CDinterviewRecord",
                        path:"/cm/pm/interviewRecord",
                        hidden:true,
                        component:"CDinterviewRecord",
                        name:"项目总监管理---访谈记录"
                    },
                    {
                        pageAddress:"cd/CDprojectDirector",
                        path:"/cm/pm/projectDirector",
                        hidden:true,
                        component:"CDprojectDirector",
                        name:"查看项目总监"
                    },
                    {
                        pageAddress:"cd/CDProjectManagerEditView",
                        path:"/cd/pm/edit",
                        hidden:true,
                        component:"CDProjectManagerEditView",
                        name:"项目总监详情"
                    },
                ]
            }
        ]

    },
    // {
    //     path: '/p7',
    //     component: "HomeView",
    //     name: '客户管理',
    //     disable:true,//无权限
    // },
    {
		path:'/p8',
        redirect: '/cm/information/changePW',
        component: "HomeView",
        name: '系统管理',
        parent:true,
        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"个人设置",
                children:[
                    // { 
                    //     pageAddress:"cm/CMChangePWView",
                    //     path:"/cm/information/changePW",
                    //     component:"CMChangePWView",
                    //     name:"修改密码" 
                    // },
                ]
            }
        ]

    },
    
];

export default menuED;


// WEBPACK FOOTER //
// ./src/menu/MenuExecutiveDean.js